import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ColorModeContext, useMode } from "./theme";
import { CssBaseline, ThemeProvider, Box } from "@mui/material";
import AdminAuth from "./Components/LoginRegister/AdminAuthenticatio";
// import Dashboard from "./Components/Dashboard/Dashboard";
import Dashboard2 from "./Components/Dashboard/Dashboard2";
import Recording from './Components/RecordingTable/ViewRecording';
import AddRecording from "./Components/RecordingTable/AddRecording";
import AdminManagement from "./Components/Admin/AdminManagement";
import AddAdmin from "./Components/Admin/AddAdmin";
import Report from "./Components/Report/Report";
import AdminDetail from "./Components/Admin/Admindetail";
import ValidationLogs from "./Components/Report/ValidationLogs";
import MandiPartner from "./Components/MandiPartner/MandiParnter";
import IvrCallLogs from "./Components/IvrCallLogs/IvrDashboardTable";
import LogsViewer from "./Components/LogModule/logViewers";
import Variety from "./Components/Variety/Variety";
import VarietyDetail from "./Components/Variety/VarietyDetail";
import Buyer from "./Components/Buyer/Buyer";
import ProtectedRoute from "./ProtectedRoute";
import IVRManualDashboardV2 from "./Components/IvrCallLogs/IvrAnaylitcs";
import PendingMandiReport from "./Components/IvrCallLogs/PendingMandiReport";
import ReportByFilterType from "./Components/IvrCallLogs/ReportByFilterType";
import MandiPartnerDetail from "./Components/MandiPartner/MandiPartnerDetail";
import DeletedMandiPartner from "./Components/MandiPartner/Deletedmandipartner"
import ReportByBuyerWise from "./Components/IvrCallLogs/ReportByBuyerWise";

function App() {
  const [theme, colorMode] = useMode();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Box>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<AdminAuth />} />

              {/* Protected Routes */}
              <Route path="/dashboard" element={<ProtectedRoute> <Dashboard2 /> </ProtectedRoute>} />
              <Route path="/recordings" element={<ProtectedRoute> <Recording /></ProtectedRoute>} />
              <Route path="/recordings/add" element={<ProtectedRoute> <AddRecording /> </ProtectedRoute>} />
              <Route path="/admins" element={<ProtectedRoute> <AdminManagement /> </ProtectedRoute>} />
              <Route
                path="/admins/add"
                element={
                  <ProtectedRoute>
                    <AddAdmin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admins/view/:id"
                element={
                  <ProtectedRoute>
                    <AdminDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/report"
                element={
                  <ProtectedRoute>
                    <Report />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/validation-logs"
                element={
                  <ProtectedRoute>
                    <ValidationLogs />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/MandiPartner"
                element={
                  <ProtectedRoute>
                    <MandiPartner />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ivr-dashboard"
                element={
                  <ProtectedRoute>
                    <IvrCallLogs />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ivr-anaylitics"
                element={
                  <ProtectedRoute>
                    <IVRManualDashboardV2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/logs"
                element={
                  <ProtectedRoute>
                    <LogsViewer />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/variety"
                element={
                  <ProtectedRoute>
                    <Variety />
                  </ProtectedRoute>
                }
              />
              <Route path="/variety-detail/:id" element={<ProtectedRoute> <VarietyDetail /></ProtectedRoute>} />
              <Route path="/buyers" element={<ProtectedRoute> <Buyer /> </ProtectedRoute>} />
              <Route path="/pending-mandi-report" element={<ProtectedRoute> <PendingMandiReport /> </ProtectedRoute>} />
              <Route path="/report-by-filter-type/:filterType" element={<ReportByFilterType />} />

              <Route path="/report-by-buyer-wise/:filterType" element={<ReportByBuyerWise />} />
              <Route path="/mandi-partner/:id" element={<ProtectedRoute> <MandiPartnerDetail /></ProtectedRoute>} />
              <Route path="/mandi-partner/deleted" element={<ProtectedRoute> <DeletedMandiPartner /></ProtectedRoute>} />
            </Routes>
          </Box>
        </Router>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;